import { cn } from '@/lib/utils'
import { useTranslation } from '@pancakeswap/localization'
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react'
import React from 'react'
import { Column } from '@tanstack/react-table'

export default function SortTable<T>({ name, column }: { name: string; column: Column<T> }) {
  const { t } = useTranslation()
  const isSorted = column.getIsSorted()

  return (
    <button
      type={'button'}
      onClick={() => column.toggleSorting(column.getIsSorted() ? column.getIsSorted() === 'asc' : true)}
      className={cn('flex items-center gap-1 cursor-pointer', {
        'text-primary': isSorted,
      })}
    >
      {t(name)}
      {isSorted && (
        <>{isSorted === 'desc' ? <ArrowDownIcon className="size-4" /> : <ArrowUpIcon className="size-4" />}</>
      )}
      {!isSorted && <div className={'size-4'} />}
    </button>
  )
}
